import styled from 'styled-components';

export default {
	BlankStyle: styled.span`
		display: inline-block;
		border: 1px dotted gray;
		border-radius: 1em;
		padding:1px;
		position:relative;
		background-color : ${ ({ blankColor }) => blankColor ? blankColor : 'white'};
		${
	({ blankSize }) => blankSize && `
				width : ${blankSize}rem;`
}
	`,
	HiddenText: styled.span`
		visibility:hidden;
	`,
	Annotation: styled.span`
		position:absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	`
};